import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  Input,
  Label,
  ModalBody,
  Row,
} from "reactstrap";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import {
  CLUSTER_QUERY_KEY,
  VIEW_CLUSTER_QUERY_KEY,
  clusterService,
} from "../../../../../Services/clusterService";
import {
  REGION_QUERY_KEY,
  VIEW_REGION_QUERY_KEY,
  regionService,
} from "../../../../../Services/regionsService";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Btn } from "../../../../../AbstractElements";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { Region } from "../../../../../Types/MasterData/Region";
import {
  Cluster,
  ViewCluster,
} from "../../../../../Types/CompanyProfile/Cluster";
import {
  deploymentsiteService,
  VIEW_DEPSITE_QUERY_KEY,
} from "../../../../../Services/deploymentsiteService";

const INITIAL_STATE = {
  id: 0,
  name: "",
  cluster: 0,
};

interface UpdateFormProps {
  toggle?: () => void;
  deploymentsite_id: number; // required
}

const CreateDeploymentSiteForm: React.FC<UpdateFormProps> = ({
  deploymentsite_id,
  toggle,
}) => {
  const queryClient = useQueryClient();
  const user = useAppSelector((state) => state.auth.user);
  const [formData, setFormData] = useState(INITIAL_STATE);

  const { data: deployementSiteData, isLoading: isFetching } = useQuery({
    queryKey: [VIEW_DEPSITE_QUERY_KEY, deploymentsite_id],
    queryFn: () =>
      deploymentsiteService.getViewDeploymentSiteById(deploymentsite_id),
  });

  useEffect(() => {
    if (deployementSiteData) {
      setFormData({
        id: deployementSiteData.id || deploymentsite_id,
        name: deployementSiteData.name || "",
        cluster: deployementSiteData.cluster_id || "",
      });
    }
  }, [deployementSiteData]);

  const updateMutation = useMutation({
    mutationFn: (data: typeof formData) =>
      deploymentsiteService.updateDeploymentSite(deploymentsite_id, data),
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: VIEW_DEPSITE_QUERY_KEY });

      toast.success(result.message);
      if (toggle) toggle();
    },
    onError: (error: any) => {
      const responseData = error.response?.data;
      if (responseData?.message) {
        toast.error(responseData.message);
      } else {
        toast.error("Failed to update deployment site.");
      }
    },
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!user) {
      toast.error("User not authenticated");
      return;
    }
    updateMutation.mutate(formData);
  };

  return (
    <ModalBody>
      <Form className="needs-validation" onSubmit={handleSubmit}>
        <Row className="g-3">
          <Col md="12">
            <Label>
              Name<b className="text-danger">*</b>
            </Label>
            <Input
              id="name"
              name="name"
              type="text"
              placeholder="Enter Deployment Site Name"
              maxLength={150}
              minLength={3}
              required
              value={formData.name}
              onChange={handleInputChange}
            />
          </Col>

          <Col xs="12">
            <Btn
              color="primary"
              className="w-100"
              type="submit"
              disabled={updateMutation.isPending}
            >
              {updateMutation.isPending
                ? "Updating Deployment Site..."
                : "Update"}
            </Btn>
          </Col>
        </Row>
      </Form>
    </ModalBody>
  );
};

export default CreateDeploymentSiteForm;
